import { motion, useReducedMotion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "", as = "div" }) {
  const reduce = useReducedMotion();
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      className={className}
      initial={reduce ? false : { opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </Tag>
  );
}

export function SectionHead({ eyebrow, title, intro, dark = false, align = "left" }) {
  return (
    <Reveal className={align === "center" ? "text-center" : ""}>
      <p className={`text-xs font-medium uppercase tracking-[0.28em] ${dark ? "text-gold" : "text-cherry"}`}>
        {eyebrow}
      </p>
      <h2
        className={`mt-3 font-display text-[2rem] leading-[1.08] tracking-tight sm:mt-4 sm:text-4xl lg:text-5xl ${
          dark ? "text-ivory" : "text-ink"
        } ${align === "center" ? "mx-auto max-w-3xl" : "max-w-3xl"}`}
      >
        {title}
      </h2>
      {intro ? (
        <p className={`mt-4 max-w-2xl text-base leading-relaxed sm:text-lg ${dark ? "text-ivory/75" : "text-ink/70"} ${align === "center" ? "mx-auto" : ""}`}>
          {intro}
        </p>
      ) : null}
    </Reveal>
  );
}
